import { IGoodReceive } from '@/interfaces/goodReceive';
import { formatThaiDate } from '@/utils/dataUtils';
import React from 'react';

interface IProps {
  data?: IGoodReceive;
}

const TemplateGoodReceiveInfo = ({ data }: IProps) => {
  return (
    <>
      <div className="flex flex-row mt-4 mb-2">
        <div className="basis-2/3 gap-1 flex flex-col">
          <p className="text-sm">
            <span className="font-bold">Customer :</span> {data?.customerName}
          </p>
          <p className="text-sm">
            <span className="font-bold">Ref. Doc :</span> {data?.referenceNo2}
          </p>
        </div>
        <div className="basis-1/3 gap-1 flex flex-col">
          <p className="text-sm">
            <span className="font-bold">Receipt Date :</span>{' '}
            {data?.grDate && formatThaiDate(data?.grDate)}
          </p>
          <p className="text-sm">
            <span className="font-bold">Inbound Order :</span>{' '}
            {data?.code || ''}
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-2">
        <div className="gap-1 flex flex-col">
          <p className="text-sm">
            <span className="font-bold">Supplier :</span> {data?.customerName}
          </p>
          <p className="text-sm">
            <span className="font-bold">Supplier Address :</span>{' '}
            โอลิมเปียไทยทาวเวอร์ ชั้นที่ 8 เลขที่ 444 ถนน รัชดาภิเษก แขวง
            สามเสนนอก เขตห้วยขวาง 10310
          </p>
        </div>
      </div>
    </>
  );
};

export default TemplateGoodReceiveInfo;
